import { IFlightPublicStatus } from '../../../../status/domain/models/IFlightPublicStatus';

export function isCanceledFlight(publicStatus: IFlightPublicStatus) {
	return publicStatus === 'Cancelled' || publicStatus === 'Canceled';
}
